/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-unresolved */
import React, { useState, useEffect } from 'react';
import { Paper } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import useStyle from './useStyle';
import searchIcon from '../../assets/img/iconos/searchIcon.svg';
import newButton from '../../assets/img/iconos/newButton.svg';
import { Loading, Toaster } from '../../components';
import { errorAlert } from './constants';
import getAllDocuments from '../../services/documents/getAllDocuments';
import DocumentsTable from './components/DataTable/DocumentsTable';
import ActionForm from './components/ActionForm/ActionForm';

const defaultData = {
  placeHolder: '',
  documentName: '',
  id: '',
  documentType: '',
  titleInfo: '',
  textInfo: '',
  iconPlaceholder: '',
};

const DocumentationScreen = () => {
  const classes = useStyle();
  const [alert, setAlert] = useState({ status: false, type: '', message: '' });
  const [enteredFilter, setEnteredFilter] = useState('');
  const [documents, setDocuments] = useState([]);
  const [defaultValues, setDefaultValues] = useState(defaultData);
  const [popUpAction, setPopUpAction] = useState({
    open: false,
    title: '',
    data: null,
  });

  const [loading, setLoading] = useState(false);

  const fetchDocuments = async () => {
    setLoading(true);
    const { data: { data: documentsData }, status } = await getAllDocuments();
    if (status !== 200) {
      setAlert(errorAlert);
    } else {
      setDocuments(documentsData);
    }
    setLoading(false);
    return documentsData;
  };

  const createNewCommercialCategory = () => {
    setDefaultValues(defaultData);
    setPopUpAction({
      open: true,
      title: 'Agregar nuevo documento',
      data: null,
    });
  };

  useEffect(() => {
    fetchDocuments();
  }, []);

  return (
    <Paper className={classes.paper}>
      {loading && <Loading />}
      <div className={classes.root}>
        <div>
          <TextField
            className={classes.searchTextField}
            value={enteredFilter}
            onChange={(e) => setEnteredFilter(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <img
                    src={searchIcon}
                    alt="searchIcon"
                    className={classes.searchIcon}
                  />
                </InputAdornment>
              ),
              disableUnderline: true,
            }}
            placeholder="Buscar"
          />
          <Tooltip
            title="Agregar documento"
            aria-label="Agregar documento"
          >
            <IconButton
              onClick={createNewCommercialCategory}
              style={{ fontSize: '20px', float: 'right' }}
              edge="end"
              size="small"
              classes={{ disabled: classes.disabled }}
            >
              <img src={newButton} alt="newButton" />
            </IconButton>
          </Tooltip>
        </div>
        <DocumentsTable
          documents={documents}
          enteredFilter={enteredFilter}
          fetchDocuments={fetchDocuments}
          setDefaultValues={setDefaultValues}
          setPopUpAction={setPopUpAction}
        />
      </div>
      <ActionForm
        open={popUpAction.open}
        title={popUpAction.title}
        defaultValues={defaultValues}
        fetchDocuments={fetchDocuments}
        onClose={() => {
          setPopUpAction({ open: false, title: '', data: null });
        }}
      />
      <Toaster
        show={alert.status}
        type={alert.type}
        text={alert.message}
        onClose={() => setAlert({ ...alert, status: false })}
      />
    </Paper>
  );
};

export default DocumentationScreen;
